export default __webpack_public_path__ + "static/media/2.9d0a5bf7.png";